<template>
   <div class="img_smain">
     <div class="img_centerdsdsds">

        <div class="center_1">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content bg-zfzx">
                <a> <div class="one">
                   <div class="img_zfjs"></div>
                    <div class="text"><span>支付结算中心</span></div>
                  </div></a>
            </div></el-col>
            <el-col :span="6">
              <!-- <a :href="url_1"  @click="wcgl()"> -->
              <div class="grid-content bg-wcgl"   @click="wcgl()">
                <a> <div class="one">
                      <div class="img_wcgl">  </div>
                        <div class="text_wxgl" style="text-align:center"><span>运营平台 </span></div>
                 </div></a>
              </div>
              <!-- </a> -->
              </el-col>
            <el-col :span="6"><div class="grid-content bg-ywxt">
                <a><div class="one">
                  <div class="img_wyxz"></div>
                     <div class="text_wxgl"><span>运维检测系统</span></div>
                 </div></a>
           </div></el-col>
            <el-col :span="6"><div class="grid-content  bg-dsj" @click="dsj()">
             <a>  <div class="one">
              <div class="img_dsjzx"></div>
                <div class="text_wxgl" style="text-align:center"><span>大数据中心</span></div>
                 </div></a>
           </div></el-col>
          <!-- <img :src="BASE_API+'/img/i.jpg'" alt=""> -->

          </el-row>

            <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content bg-tsxt" style="margin-top:20px"   @click="jqcz()">
                <a><div class="one">
                    <div class="img_jqccts"></div>
                       <div class="text_jqts"><span>机器出厂检测系统</span></div>
                 </div></a>
             </div></el-col>

            <el-col :span="6"><div class="grid-content bg-shfw" style="margin-top:20px">
                <a> <div class="one">
                  <div class="img_shfw"></div>
                     <div class="text_wxgl"><span>售后服务系统</span></div>
                 </div></a>
              </div></el-col>

            <el-col :span="6"><div class="grid-content bg-hffw" style="margin-top:20px">
                <a><div class="one">
                     <div class="img_kffwxt"> </div>
                       <div class="text_wxgl"><span>客户服务系统</span></div>
                 </div></a>

              </div></el-col>
            <el-col :span="6"><a :href="url_3" @click="pzxt()"><div class="grid-content bg-pzgl" style="margin-top:20px">
               <div class="one">
                  <div class="img_pzgl"></div>
                      <div class="text_wxgl"><span>配置管理系统</span></div>
                 </div>
              </div></a></el-col>
          </el-row>
            <!-- <el-row :gutter="20">
            <el-col :span="6"><a href="http://www.xynetweb.com:8089/#/login">
              <div class="grid-content bg-tsxt" style="margin-top:20px">
                 <div class="one">
                    <div class="img_jqccts"></div>
                       <div class="text_jqts"><span>机器出厂检测系统</span></div>
                 </div>
             </div></a></el-col>

            <el-col :span="6"><div class="grid-content bg-shfw" style="margin-top:20px">
                 <div class="one">
                  <div class="img_shfw"></div>
                     <div class="text_wxgl"><span>售后服务系统</span></div>
                 </div>
              </div></el-col>

            <el-col :span="6"><div class="grid-content bg-hffw" style="margin-top:20px">
                <div class="one">
                     <div class="img_kffwxt"> </div>
                       <div class="text_wxgl"><span>客户服务系统</span></div>
                 </div>

              </div></el-col>
            <el-col :span="6"><div class="grid-content bg-pzgl" style="margin-top:20px">
               <div class="one">
                  <div class="img_pzgl"></div>
                      <div class="text_wxgl"><span>配置管理系统</span></div>
                 </div>
              </div></el-col>
          </el-row> -->

             </div>
        </div>
   </div>

</template>
<script>
import { getSession } from '@/utils/auth'
import request from "@/utils/request";
import {BASE_API} from '@/utils/request'

 export default {
    data() {
      return {
        BASE_API,
        	usermate: this.$globalApi.getSessionStorage('userInfo'),
        formInline: {
          user: '',
          region: ''
        },
        systemid:"",
        systemuserid:"",


        //url_2:"http://www.xynetweb.com:8089/#/login",
        // url_1:"http://175.6.4.138:6007/#/login",
        url_3:"http://175.6.4.138:6011/#"
      }
    },
    methods: {
      dsj() {

          if(getSession()){
            	this.$router.push({ path: "/databases",});
          }else{
              this.$router.push({ path: "/login",});
          }
            	// this.$router.push({ path: "/databases",});
      },

      wcgl(){

        if(getSession()){//微超


          var param={
            systemid:"hgsram",
            systemuserid: JSON.parse(sessionStorage.getItem("userInfo")).userid+"",
        };
     request({url: "/sram/comm/login/getUserResource",method: "post",data:param})
       .then(response => {

            //sessionStorage.setItem('Authorization', response.session_key);
            let routers = window.JSON.stringify(response.userInfo.menuJsonTree);
            sessionStorage.setItem('routers', routers);
            sessionStorage.setItem('userInfo', window.JSON.stringify(response.userInfo));
             this.$router.push({routers});

        this.$message({ message: response.msg, type: "success" });

      }).catch(error => {
        this.$message({ message: response.msg, type: "error" });
      });

             this.$router.push({ path: "/dashboard",});
          // this.url_1= "http://175.6.4.138:6007/#/login"
          // this.$router.push({ path: "/wclogin",});
          //跳到每个模块的主页
        }
        else{
              this.$router.push({ path: "/login",});
        }
      },
      jqcz(){

         if(getSession()){//机器出厂

           window.location.href = "http://192.168.1.149:9898/#/home?athorization=" + getSession() +"&userid="+ JSON.parse(sessionStorage.getItem("userInfo")).userid;
          //   window.location.href =  'http://www.xynetweb.com:8089/#/home?athorization=' + getSession();
          //   window.location.href ='http://www.xynetweb.com:8089/#/home?Authorization=' + getSession();
          // 跳到每个模块的主页
        }else{
           this.$router.push({ path: "/login",});
        }
     },
     pzxt(){//配置中心
        if(getSession()){
            this.url_3='http://175.6.4.138:6011/#';
          //跳到每个模块的主页
        }else{
           this.$router.push({ path: "/login",});
        }
     },






      wxxt(){
           	// this.$router.push({ path: "http://www.xynetweb.com:8089/#/login",});
      }
    }
  }

</script>

<style scoped>
 .img_smain>.img_centerdsdsds {

  height: 100%;
	width: 100%;
	overflow: hidden;
	position: fixed;
	background:url(http://www.xynetweb.com:8086/sysFile/bjt.png)no-repeat;
	background-size:cover;
}
.center_1{
  width: 80%;
  height:495px;
  margin: 0 auto;
  position: relative;
    top: 110px;
}

.bg-dsj{
  background:#219A93
}
.bg-wcgl{
  background:#208B3D
}
.bg-ywxt{
  background:#31AAE3
}
.bg-zfzx{
  background:#591D7D
}
.bg-tsxt{
  background: #1267AA
}
.bg-shfw{
  background:#F56161
}
.bg-hffw{
  background:#219A93
}
.bg-pzgl{
  background:#DF9D38
}
.img_dsjzx{
   width: 88px;
   height: 79px;
   position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    background:url(img/dsjzx.png)no-repeat
}
.img_wcgl{
   width: 88px;
   height: 79px;
 position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
 background:url(img/wcgl.png)no-repeat
}
.img_wyxz{
    width: 88px;
    height: 79px;
 position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
 background:url(img/wyxz.png)no-repeat
}
.img_zfjs{
    width: 88px;
   height: 79px;
 position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
 background:url(img/zfjs.png)no-repeat
}
.img_jqccts{
    width: 88px;
    height: 79px;
 position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
 background:url(img/jqccts.png)no-repeat
}
.img_shfw{
    width: 88px;
    height: 79px;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
 background:url(img/shfw.png)no-repeat
}
.img_kffwxt{
    width: 88px;
    height: 79px;
 position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
 background:url(img/kffwxt.png)no-repeat
}
.img_pzgl{
    width: 88px;
    height: 79px;
   position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
 background:url(img/pzglxt.png)no-repeat
}
.text{
    width: 150px;
    height: 79px;
   position: absolute;
    top: 68%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
}
.text>span{
  font-size: 24px;
  font-weight: 600;
  color: #ffffff
}
.text_jqts{
   width: 200px;
   height: 79px;
  position: absolute;
    top: 68%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
}
.text_jqts>span{
   font-size: 24px;
   font-weight: 600;
   color: #ffffff
}
.text_wxgl{
   width: 150px;
   height: 79px;
  position: absolute;
    top: 68%;
    left: 50%;
    transform: translate(-50%,-50%);
    line-height: 100px;
}
.text_wxgl>span{
   font-size: 24px;
   font-weight: 600;
   color: #ffffff
}

.one{
  position: relative;
  height: 180px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/databases/database.vue